import Features from "./landing_home/features"
import Navigation from "../navigation/header"
import Home from "./landing_home/landing_home"
import ProductsLanding from "./landing_home/productsLanding"
import Challenges from "./landing_home/challenges"
import WhyUsSection from "./landing_home/why_us"
import CTASection from "./landing_home/empower"
import TestimonialsSection from "./landing_home/testimonial"
import Footer from "../Footer/footer"
import FloaterCard from "../floater/floaterCard"

function Main() {
  return (
    <div className="App">
      <Navigation/>
      <Home/>
      <Features/>
      <ProductsLanding />
      <Challenges/>
      <WhyUsSection/>
      <TestimonialsSection/>
      <CTASection/>
     <Footer/>
     {/* <FloaterCard /> */}
    </div>
  );
}

export default Main;